import { Box } from "@mui/material"
import type { FC } from "react"

import { usePriceApprovalList } from "../hooks/usePriceApprovalList"

import { PriceApprovalTable } from "./PriceApprovalTable"

export const PriceApprovalsTabPanel: FC = () => {
  const { priceApprovals, isFetching, error, sorting, tableContainerRef, handleScroll, handleSortingChange } =
    usePriceApprovalList()

  return (
    <Box className='flex min-h-0 flex-1 overflow-y-auto' data-testid='dashboard.price-approvals-tab-panel'>
      <PriceApprovalTable
        data={priceApprovals}
        loading={isFetching}
        error={error}
        sorting={sorting}
        containerRef={tableContainerRef}
        onScroll={handleScroll}
        onSortingChange={handleSortingChange}
      />
    </Box>
  )
}
